import { render, staticRenderFns } from "./transferislem.vue?vue&type=template&id=21a74e0e&scoped=true&"
import script from "./transferislem.vue?vue&type=script&lang=js&"
export * from "./transferislem.vue?vue&type=script&lang=js&"
import style0 from "./transferislem.vue?vue&type=style&index=0&id=21a74e0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a74e0e",
  null
  
)

export default component.exports